{
	"cancel": "Cancelar",
	"ok": "Ok",
	"title": "Confirmación requerida"
}
